import { http } from '@/public/utils/http'

let menuIconMap = null

export const getMenuIcon = async () => {
  if (menuIconMap) return menuIconMap
  const res = await http('system.menuIconConfig.list', {})
  menuIconMap = res.reduce((acc, item) => {
    acc[item.menuUrl] = item.menuIcon
    return acc
  }, {})
  return menuIconMap
}



// WEBPACK FOOTER //
// ./src/layout/pages/home/common-menu-card/menuIcon.js